import React, { Component } from 'react';
import '../css/App.css';



class AssignedModulesParentComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: []
        };
    }
    componentWillMount() {

    }

    render() {
        if(this.props.lock){
        return (
            <div className="area col-md-12" onClick={() => this.props.Onpress()} >
                <h4 className="text-white mZero">{this.props.ParentComponentTitle}</h4><span className="align-item-center"><span className="topic">{this.props.UnitsCount} Unit(s)</span> {this.props.ui_open === true ?
                    <i className="material-icons">
                        keyboard_arrow_down
</i> : <i className="material-icons">
                        keyboard_arrow_right
</i>}</span>
{this.props.completed &&  <i className="material-icons completed" style={{background:this.props.completed}}>
                                            done
                                            </i>}
            </div>
        );
                }else{
                    return (
                        <div className="area col-md-12" onClick={() => this.props.OnAlert()} >
                            <h4 className="text-white mZero">{this.props.ParentComponentTitle}</h4><span className="align-item-center"><span className="topic">{this.props.UnitsCount} Unit(s)</span> {this.props.ui_open === true ?
                                <i className="material-icons">
                                    keyboard_arrow_down
            </i> : <i className="material-icons">
                                    keyboard_arrow_right
            </i>}</span>
            {this.props.completed &&  <i className="material-icons completed" style={{background:this.props.completed}}>
                                                        done
                                                        </i>}
                        </div>
                    );
                }
    }
}

export default AssignedModulesParentComponent;